export default "/palm/assets/images/lst-vaults-banner.svg"